import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './CompareButton.module.scss';

const cx = classNames.bind(styles);

const getCookie = (cookie: string, name: string) => {
  const value = cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return value ? value[2] : null;
};

const CompareButton = ({ innerText }: { innerText?: string }) => {
  const [compareList, setCompareList] = useState([]);

  useEffect(() => {
    if (window) {
      const list = JSON.parse(decodeURIComponent(getCookie(document.cookie, 'pkgtour_compare') || '') || '[]');
      setCompareList(list);
    }
  }, []);

  return (
    <div className={cx('CompareButton')}>
      <a
        className={cx('btn')}
        aria-label={!innerText ? '비교하기' : undefined}
        data-testid="compare"
        aria-expanded={true}
        target="_blank"
        rel="noreferrer"
        href={`/compare/${
          compareList.length > 0 ? compareList.join(',') + '?productIds=' + compareList.slice(0, 5).join(',') : ''
        }`}
      >
        {innerText}
        <b className={cx('count')} data-testid="compareCount">
          {compareList.length || 0}
        </b>
      </a>
    </div>
  );
};

export default CompareButton;
